
<script>
export default {
  // 페이지 로드시 이미지 로드 완료 검사 위한 메소드
  methods: {
    loadImages(images) {
      return new Promise(res => {
        const loadImgArr = new Array();
        let loadCompleteCount = 0;
        for (const imgSrc of images) {
          const img = new Image();
          img.src = imgSrc;
          loadImgArr.push(img);
          img.onload = () => {
            loadCompleteCount++;
            if (images.length === loadCompleteCount) {
              res();
            }
          };
        }
      });
    }
  }
};
</script>